import React from 'react';
import { getCatalogueContent } from '../trainingContent';
import { trackTrainingEvent } from '../trainingAnalytics';
import { getOfferPath } from '../trainingRoutes';
import { formatDuration, formatTotal } from '../trainingFormat';

export default function OfferCard({ offer, locale, position, recommended = false }) {
  const content = getCatalogueContent(locale);
  const cardContent = content.offerCards.find(({ key }) => key === offer.key);
  const duration = formatDuration(offer.duration, locale);

  const handleClick = () => {
    try {
      trackTrainingEvent('offer_card_click', {
        offerKey: offer.key,
        locale,
        cardPosition: position,
      });
    } catch {
      // A tracking failure must never prevent native navigation.
    }
  };

  return (
    <article
      className="offer-card"
      data-duration={duration}
      data-recommended={recommended ? 'true' : undefined}
    >
      {recommended ? (
        <p className="offer-card__match">{content.comparator.matchBadge}</p>
      ) : null}
      <p className="offer-card__duration">{duration}</p>
      <h2 className="offer-card__title">{cardContent.name}</h2>
      <p className="offer-card__positioning">{cardContent.positioning}</p>
      <dl className="offer-card__facts">
        <div className="offer-card__fact">
          <dt>{content.compareLabels.bestFor}</dt>
          <dd>{cardContent.bestFor}</dd>
        </div>
        <div className="offer-card__fact">
          <dt>{content.compareLabels.approach}</dt>
          <dd>{cardContent.approach}</dd>
        </div>
      </dl>
      <p className="offer-card__total">{formatTotal(offer.total)}</p>
      <a
        className="offer-card__link"
        href={getOfferPath(locale, offer.key)}
        onClick={handleClick}
      >
        {content.detailCta}
      </a>
    </article>
  );
}
